import React from 'react'
import Link from 'gatsby-link'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import SubdirectoryArrowRightIcon from '@material-ui/icons/SubdirectoryArrowRight'
import SvgIcon from '@material-ui/core/SvgIcon'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'

import CustomSvg from '../../components/custom-svg'
import PdfLink from '../../components/pdf-link'

import { ReactComponent as PdfIcon } from '../../assets/images/pdf.svg'
import { ReactComponent as TargetIcon } from '../../assets/images/sanctions-blue.svg'

const styles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(1.5)
  },

  link: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.typography.body2.fontSize,
    textDecoration: 'none',
    color: 'inherit',
    paddingTop: '5px',
    paddingBottom: '5px'
  },

  subtitle: {
    color: theme.palette.grey[500],
    display: 'block'
  },

  titleWrapper: {
    paddingRight: theme.spacing(1)
  },

  linkIconGo: {
    color: theme.palette.primary.main,
    marginLeft: 'auto',
    marginRight: '0'
  },

  linkIconDownload: {
    color: theme.palette.grey[500],
    width: '16px',
    height: '16px'
  },

  caseIcon: {
    color: theme.palette.grey[500],
    marginRight: '6px',
    width: '12px',
    height: '12px'
  },

  targetIcon: {
    position: 'relative',
    top: '1px',
    width: '18px',
    height: '18px',
    marginRight: '6px'
  },

  pdfIcon: {
    position: 'relative',
    top: '3px',
    marginRight: '6px'
  },

  customTargetIconWrap: {
    position: 'relative',
    top: '3px',
    marginRight: '6px',

    '& svg': {
      width: '18px',
      height: '18px',
      marginTop: '-2px'
    }
  }
}))

export default function ListLink(props) {
  const classes = styles(props)

  const linkStartIcon = (
    <div className={classes.linkIcon}>
      {props.type === 'case' ? <SubdirectoryArrowRightIcon className={classes.caseIcon} /> : null}
      {props.type === 'pdf' ? <SvgIcon component={PdfIcon} className={classes.pdfIcon} /> : null}
      {props.type === 'target' && props.icon ? (
        <CustomSvg content={props.icon.iconSource} className={classes.customTargetIconWrap} />
      ) : null}
      {props.type === 'target' && !props.icon ? (
        <SvgIcon component={TargetIcon} viewBox="0 0 18 18" className={classes.targetIcon} />
      ) : null}
    </div>
  )

  const linkTitle =
    props.title || props.subtitle ? (
      <div className={classes.titleWrapper}>
        {props.title}
        {props.subtitle ? (
          <Typography variant="subtitle1" className={classes.subtitle}>
            {props.subtitle}
          </Typography>
        ) : null}
      </div>
    ) : null

  const linkEndIcon =
    props.type === 'pdf' ? (
      <ArrowDownwardIcon className={classes.linkIconDownload} />
    ) : (
      <NavigateNextIcon className={classes.linkIconGo} />
    )

  const linkInner = (
    <>
      {linkStartIcon}
      {linkTitle}
      {linkEndIcon}
    </>
  )

  // PDF should link to external url
  return props.type === 'pdf' ? (
    <PdfLink
      to={props.to}
      className={classes.link + ' ' + 'ListLink-pdf'}
      target="_blank"
      rel="noopener noreferrer"
      starticon={linkStartIcon}
      title={linkTitle}
    >
      {linkInner}
    </PdfLink>
  ) : (
    <Link to={props.to} className={classes.link}>
      {linkInner}
    </Link>
  )
}
